import { api } from './api';
import type { Concept, ConceptDraft, ConceptPatch, ConceptRevision } from '@sr-test-wizard/shared';

interface EditMeta {
  editor?: string;
  reason?: string;
}

/**
 * Thin wrappers around /api/ontology. Edits carry an optional `_meta`
 * ({editor, reason}); a reason is required server-side when regulatory
 * relevance is set/changed, and is recorded in the append-only revision log.
 */
export const ontologyApi = {
  list: () => api.get<Concept[]>('/api/ontology'),
  get: (id: string) => api.get<Concept>(`/api/ontology/${encodeURIComponent(id)}`),
  create: (draft: ConceptDraft, meta?: EditMeta) =>
    api.post<Concept>('/api/ontology', { ...draft, _meta: meta ?? {} }),
  update: (id: string, patch: ConceptPatch, meta?: EditMeta) =>
    api.put<Concept>(`/api/ontology/${encodeURIComponent(id)}`, { ...patch, _meta: meta ?? {} }),
  remove: (id: string) =>
    api.delete<{ id: string; removed: boolean }>(`/api/ontology/${encodeURIComponent(id)}`),
  revisions: (id: string) =>
    api.get<ConceptRevision[]>(`/api/ontology/${encodeURIComponent(id)}/revisions`),
  suggest: (text: string) =>
    api.post<Array<{ slug: string; canonicalName: string; method: string; score: number }>>(
      '/api/ontology/suggest',
      { text },
    ),
};
